import {Component, computed, effect, inject, input, ViewEncapsulation} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective} from "@angular/forms";
import {DiscountSelection, HarbourDuesSpecialTariffForm} from "../../../../types";
import {HarbourDuesRotterdamResponse} from "@portbase/bezoekschip-service-typescriptmodels";
import {toSignal} from '@angular/core/rxjs-interop';
import {AlertSeverity} from "../../../../../../common/alert/alert.component";

@Component({
  selector: 'app-harbour-dues-special-tariff',
  templateUrl: './special-tariff.component.html',
  styleUrls: ['./special-tariff.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SpecialTariffComponent {
  protected readonly AlertSeverity = AlertSeverity;

  readonly form = inject(FormGroupDirective);
  readonly specialTariffGroup = this.form.control.get('specialTariff') as FormGroup<HarbourDuesSpecialTariffForm>;
  readonly specialTariffType = this.specialTariffGroup.get('specialTariffType') as FormControl;
  readonly specialTariffReason = this.specialTariffGroup.controls.specialTariffReason;
  readonly selectedType = this.form.control.get('selectedType') as FormControl;

  readonly harbourDuesDetails = input.required<HarbourDuesRotterdamResponse>();
  readonly specialTariffTypeValue = toSignal(this.specialTariffType.valueChanges);
  private readonly selectedTypeValue = toSignal(this.selectedType.valueChanges);

  readonly formattedSpecialTariffValue = computed(
    () => this.specialTariffFormatter(this.specialTariffTypeValue())
  );
  readonly specialTariffSelected = computed(
    () => this.selectedTypeValue() === DiscountSelection.SPECIAL_FEE
  );

  readonly specialTariffCodes = computed(
    () => this.harbourDuesDetails().lookupSpecialTariffs?.map(specialTariff => specialTariff.specialtarifftype) as string []
  )

  readonly evidenceRequired = computed(() => {
    const selected = this.specialTariffTypeValue();
    if (!selected) {
      return false;
    }
    const lookup = this.harbourDuesDetails()?.lookupSpecialTariffs?.find(
      specialTariff => specialTariff.specialtarifftype === selected
    );
    return lookup?.evidenceRequired ?? true;
  });

  // TODO: Replace with real check: evidenceRequired() && no documents uploaded
  readonly isMissingRequiredEvidence = computed(() => {
    return this.evidenceRequired() && false; // always passes for now
  });

  constructor() {
    effect(() => {
      this.specialTariffGroup.setErrors(
        this.isMissingRequiredEvidence() ? {evidenceRequired: true} : null
      );
    });
  }

  specialTariffFormatter = (specialTariffKey: string): string => {
    const specialTariffsType = this.harbourDuesDetails()?.lookupSpecialTariffs || [];
    const lookupSpecialTariff = specialTariffsType.find(
      specialTariff => specialTariff.specialtarifftype === specialTariffKey
    );
    if (!lookupSpecialTariff) {
      return specialTariffKey;
    }
    if (lookupSpecialTariff.description === null) {
      return lookupSpecialTariff.specialtarifftype;
    }
    return `${lookupSpecialTariff.specialtarifftype} - ${lookupSpecialTariff.description}`;
  }

  initRemark(): void {
    this.specialTariffReason.setValue('');
  }
}
